// import logo from './logo.svg';
import './App.css';

import { lazy, Suspense, useEffect } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import axios from "axios";
import { GoogleOAuthProvider } from '@react-oauth/google';

import { globalState, googleClientID, accessTokenKey, baseUrl } from "./utils/config";

import alertify from "./assets/alertifyjs/alertify.js";
import "./assets/alertifyjs/css/alertify.css";

/*const Header = lazy(function () { return import ("./components/layouts/Header") });
const Footer = lazy(function () { return import ("./components/layouts/Footer") });
const Home = lazy(function () { return import ("./components/Home") });
const Post = lazy(function () { return import ("./components/Post") });
const SignUp = lazy(function () { return import ("./components/SignUp") });
const Login = lazy(function () { return import ("./components/Login") });
const ForgotPassword = lazy(function () { return import ("./components/ForgotPassword") });
const ResetPassword = lazy(function () { return import ("./components/ResetPassword") });
const Notifications = lazy(function () { return import ("./components/Notifications") });
const Jobs = lazy(function () { return import ("./components/Jobs") });
const MyJobs = lazy(function () { return import ("./components/MyJobs") });
const EditJob = lazy(function () { return import ("./components/EditJob") });
const FeatureJob = lazy(function () { return import ("./components/FeatureJob") });
const JobDetail = lazy(function () { return import ("./components/JobDetail") });
const CVManager = lazy(function () { return import ("./components/CVManager") });
const MyApplied = lazy(function () { return import ("./components/MyApplied") });
const ApplicationDetail = lazy(function () { return import ("./components/ApplicationDetail") });
const Search = lazy(function () { return import ("./components/Search") });
const About = lazy(function () { return import ("./components/About") });
const Contact = lazy(function () { return import ("./components/Contact") });
const Buy = lazy(function () { return import ("./components/Buy") });
const FAQs = lazy(function () { return import ("./components/FAQs") });
const Services = lazy(function () { return import ("./components/Services") });
const Profile = lazy(function () { return import ("./components/Profile") });
const Bookmarks = lazy(function () { return import ("./components/Bookmarks") });
const Followings = lazy(function () { return import ("./components/Followings") });
const Recruiter = lazy(function () { return import ("./components/Recruiter") });
const UserProfile = lazy(function () { return import ("./components/UserProfile") });
const Users = lazy(function () { return import ("./components/Users") });*/

import Header from "./components/layouts/Header";
import Footer from "./components/layouts/Footer";
import BuyHeader from "./components/layouts/BuyHeader.js";
import Home from "./components/Home";
import Post from "./components/Post";
import SignUp from "./components/SignUp";
import Login from "./components/Login";
import Verify from "./components/Verify";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Notifications from "./components/Notifications";
import Jobs from "./components/Jobs";
import MyJobs from "./components/MyJobs";
import EditJob from "./components/EditJob";
import FeatureJob from "./components/FeatureJob";
import JobDetail from "./components/JobDetail";
import CVManager from "./components/CVManager";
import MyApplied from "./components/MyApplied";
import ApplicationDetail from "./components/ApplicationDetail";
import Search from "./components/Search";
import About from "./components/About";
import Contact from "./components/Contact";
import Buy from "./components/Buy";
import FAQs from "./components/FAQs";
import Services from "./components/Services";
import Profile from "./components/Profile";
import Bookmarks from "./components/Bookmarks";
import Followings from "./components/Followings";
import Recruiter from "./components/Recruiter";
import UserProfile from "./components/UserProfile";
import Users from "./components/Users";
import Inbox from "./components/Inbox";

function App() {

  const titles = {
    "/": "Home - Job Entry",
    "/about": "About - Job Entry",
    "/contact": "Contact - Job Entry",
  };

  async function fetchSettings() {
    try {
      const response = await axios.post(
        baseUrl + "/api/fetch-settings",
        null,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
          }
        }
      );

      if (response.data.status == "success") {
        const settings = response.data.settings;
        globalState.setState({
          settings: settings
        });

        if (typeof settings.tidio !== "undefined") {
          var script = document.createElement("script");
          script.setAttribute("src", settings.tidio);
          script.setAttribute("async", "true");
          document.body.appendChild(script);
        }

        if (typeof settings.stripe_pk !== "undefined") {
          var script = document.createElement("script");
          script.setAttribute("src", "https://js.stripe.com/v3");
          script.setAttribute("async", "true");
          document.body.appendChild(script);
        }
      }
    } catch (exp) {
      console.log(exp.message);
    }
  }

  function initSSE() {
    if (typeof EventSource !== "undefined") {
      const sse = new EventSource(baseUrl + "/sse-stream?token=" + localStorage.getItem(accessTokenKey));
      let newMessages = 0;
      
      sse.onmessage = function (event) {
        const response = JSON.parse(event.data);
        // console.log(response);

        if (globalState.state.user != null) {
          const user = globalState.state.user;

          if (typeof response.jobs_notifications !== "undefined")
            user.jobs_notifications = response.jobs_notifications || 0;

          let updateObj = {
            user: user
          };

          if (typeof response.new_messages !== "undefined") {
            updateObj.newMessages = response.new_messages || 0;
          }

          updateObj.totalNotifications = user.jobs_notifications + updateObj.newMessages;
          globalState.setState(updateObj);

          if (updateObj.newMessages > 0 && updateObj.newMessages != newMessages) {
            alertify.notify("New message", "success", 5);
            newMessages = updateObj.newMessages;
          }
        }
      };

      // sse.onerror = function (error) {
      //   console.log(error);
      // };
    }
  }

  useEffect(function () {
    const path = window.location.pathname;
    document.title = titles[path] || "Job Entry";

    fetchSettings();
    initSSE();
  }, []);

  return (
    <>
      <GoogleOAuthProvider clientId={ googleClientID }>
	  {/*
        <BuyHeader />
	*/}
        <div className="container-xxl bg-white p-0">
          <BrowserRouter>
            <Header />
            {/*<Suspense fallback={ <h3>Loading...</h3> }>*/}
              <Routes>
                <Route path="/inbox" element={ <Inbox /> } />
                <Route path="/find-talent" element={ <Users /> } />
                <Route path="/user/:id" element={ <UserProfile /> } />
                <Route path="/recruiter/:id" element={ <Recruiter /> } />
                <Route path="/followings" element={ <Followings /> } />
                <Route path="/bookmarks" element={ <Bookmarks /> } />
                <Route path="/profile/:type?" element={ <Profile /> } />
                <Route path="/services" element={ <Services /> } />
                <Route path="/faqs" element={ <FAQs /> } />
                <Route path="/pricing" element={ <Buy /> } />
                <Route path="/contact" element={ <Contact /> } />
                <Route path="/about" element={ <About /> } />
                <Route path="/search" element={ <Search /> } />
                <Route path="/application/:id" element={ <ApplicationDetail /> } />
                <Route path="/my-applied" element={ <MyApplied /> } />
                <Route path="/cv-manager" element={ <CVManager /> } />
                <Route path="/jobs/:id/feature" element={ <FeatureJob /> } />
                <Route path="/jobs/:id/edit" element={ <EditJob /> } />
                <Route path="/jobs/:id" element={ <JobDetail /> } />
                <Route path="/jobs" element={ <Jobs /> } />
                <Route path="/my" element={ <MyJobs /> } />
                <Route path="/notifications" element={ <Notifications /> } />
                <Route path="/reset-password/:email" element={ <ResetPassword /> } />
                <Route path="/forgot-password" element={ <ForgotPassword /> } />
                <Route path="/verify" element={ <Verify /> } />
                <Route path="/login" element={ <Login /> } />
                <Route path="/signup" element={ <SignUp /> } />
                <Route path="/post" element={ <Post /> } />
                <Route path="/" element={ <Home /> } />
              </Routes>
            {/*</Suspense>*/}

            <Footer />
          </BrowserRouter>
        </div>
      </GoogleOAuthProvider>

      {/*<div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            Edit <code>src/App.js</code> and save to reload.
          </p>
          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn React
          </a>
          </header>
        </div>*/}
    </>
  );
}

export default App;
